export default __webpack_public_path__ + "static/media/AlertsGray.e49e6c4a.png";